import HttpRequest from './HttpRequest';

export const getWritings = async () => {
  try {
    const response = await HttpRequest.get('/writings');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
